import { Component, ElementRef, OnInit } from '@angular/core';
import { Log } from '@s8l/client-tree-lib';

import { AnalyticsMetric, StatsService } from 'src/app/services/stats.service';

import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-users-widget',
  templateUrl: './users-widget.component.html',
  styleUrls: ['./users-widget.component.scss']
})
export class UsersWidgetComponent extends HomeWidget implements OnInit {
  public count: number = null;

  constructor(elRef: ElementRef, private stats: StatsService) {
    super(elRef);
  }

  ngOnInit() {
    this.stats
      .fetchMetrics(
        AnalyticsMetric.users,
        this.settings.relative,
        [],
        this.settings.filter,
        this.settings.exclude,
        this.settings.from,
        this.settings.to
      )
      .then(data => {
        this.count = data.reduce((prev, curr) => prev + curr.users, 0);
      })
      .catch(err => {
        this.count = -1;
        Log.log('UsersWidgetComponent', 'Error', err);
      });
  }
}
